<div class="flex flex-col">
  <span class="soft-overline">{{item['seriennummer']}}</span>
  <div class="flex flex-row">
    <span class="font-bold">{{item['(expression)']}}</span>
  </div>
  <div class="flex flex-row text-sm text-light">
    <span>Marke: {{ item['marke']}}, Artikelnummer: {{ item['cartikelnummer'] }} </span>
  </div>
  <div class="flex flex-row text-sm text-light">
    <span>Belegnummer: {{item['belegnummer']}}</span>
  </div>
</div>
